import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home.jsx";
import WhoWeAre from "./pages/WhoWeAre.jsx";
import Gelatinas from "./pages/Gelatinas.jsx";
import WhereToBuy from "./pages/WhereToBuy.jsx";
import Bloom220 from "./pages/Bloom220.jsx";
import Bloom250 from "./pages/Bloom250.jsx";
import NotFound from "./pages/NotFound.jsx";

export default function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-white text-slate-900">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/quienes-somos" element={<WhoWeAre />} />
          <Route path="/gelatinas" element={<Gelatinas />} />
          <Route path="/donde-comprar" element={<WhereToBuy />} />

          {/* Detalles */}
          <Route path="/gelatinas/bloom-220" element={<Bloom220 />} />
          <Route path="/gelatinas/bloom-250" element={<Bloom250 />} />

          {/* Alias si lo necesitas */}
          <Route path="/productos" element={<Navigate to="/gelatinas" replace />} />

          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
      </div>
    </BrowserRouter>
  );
}
